<template>
  <div>
    <div class="page-header">
      <h1>🗓️ 排程規則</h1>
      <p>管理固定週期的自動記帳規則</p>
    </div>

    <!-- 新增規則 -->
    <div class="card">
      <div class="card-title">➕ 新增規則</div>

      <div class="form-row">
        <div class="form-group">
          <label>類型</label>
          <select v-model="form.type" @change="onTypeChange">
            <option value="pay">支出</option>
            <option value="transfer">轉帳</option>
          </select>
        </div>

        <template v-if="form.type === 'pay'">
          <div class="form-group">
            <label>類別</label>
            <select v-model="form.item">
              <option v-for="x in categories" :key="x" :value="x">{{ x }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>帳戶</label>
            <select v-model="form.account">
              <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
            </select>
          </div>
        </template>

        <template v-if="form.type === 'transfer'">
          <div class="form-group">
            <label>來源</label>
            <select v-model="form.source">
              <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>目標</label>
            <select v-model="form.target">
              <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
            </select>
          </div>
        </template>

        <div class="form-group">
          <label>金額</label>
          <input type="number" v-model="form.amount" placeholder="金額" min="0" />
        </div>

        <div class="form-group">
          <label>備註</label>
          <input type="text" v-model="form.comment" placeholder="備註（選填）" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>觸發條件</label>
          <select v-model="form.condType">
            <option value="dom">每月第幾日</option>
            <option value="dow">每週幾</option>
            <option value="mdom">特定月份 + 日</option>
          </select>
        </div>

        <div class="form-group" v-if="form.condType === 'dom'">
          <label>日期</label>
          <input type="number" v-model="form.day_of_month" min="1" max="31" placeholder="1~31" />
        </div>

        <div class="form-group" v-if="form.condType === 'dow'">
          <label>星期</label>
          <select v-model="form.day_of_week">
            <option value="0">週一</option>
            <option value="1">週二</option>
            <option value="2">週三</option>
            <option value="3">週四</option>
            <option value="4">週五</option>
            <option value="5">週六</option>
            <option value="6">週日</option>
          </select>
        </div>

        <template v-if="form.condType === 'mdom'">
          <div class="form-group">
            <label>月份</label>
            <select v-model="form.month">
              <option v-for="m in 12" :key="m" :value="m">{{ m }} 月</option>
            </select>
          </div>
          <div class="form-group">
            <label>日期</label>
            <input type="number" v-model="form.day_of_month" min="1" max="31" placeholder="1~31" />
          </div>
        </template>
      </div>

      <div class="form-actions">
        <button class="btn btn-primary" @click="addRule" :disabled="adding">
          {{ adding ? '新增中...' : '新增規則' }}
        </button>
        <span v-if="msg" class="msg-success">✓ {{ msg }}</span>
        <span v-if="errMsg" class="msg-error">✗ {{ errMsg }}</span>
      </div>
    </div>

    <!-- 編輯 Modal -->
    <div v-if="editModal.show" class="modal-backdrop" @click.self="closeEdit">
      <div class="modal">
        <div class="modal-header">
          <span>✏️ 編輯規則</span>
          <button class="modal-close" @click="closeEdit">✕</button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>類型</label>
              <select v-model="editModal.type" @change="onEditTypeChange">
                <option value="pay">支出</option>
                <option value="transfer">轉帳</option>
              </select>
            </div>

            <template v-if="editModal.type === 'pay'">
              <div class="form-group">
                <label>類別</label>
                <select v-model="editModal.item">
                  <option v-for="x in categories" :key="x" :value="x">{{ x }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>帳戶</label>
                <select v-model="editModal.account">
                  <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
                </select>
              </div>
            </template>

            <template v-if="editModal.type === 'transfer'">
              <div class="form-group">
                <label>來源</label>
                <select v-model="editModal.source">
                  <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>目標</label>
                <select v-model="editModal.target">
                  <option v-for="x in assetList" :key="x" :value="x">{{ x }}</option>
                </select>
              </div>
            </template>

            <div class="form-group">
              <label>金額</label>
              <input type="number" v-model="editModal.amount" min="0" />
            </div>
            <div class="form-group">
              <label>備註</label>
              <input type="text" v-model="editModal.comment" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>觸發條件</label>
              <select v-model="editModal.condType">
                <option value="dom">每月第幾日</option>
                <option value="dow">每週幾</option>
                <option value="mdom">特定月份 + 日</option>
              </select>
            </div>

            <div class="form-group" v-if="editModal.condType === 'dom'">
              <label>日期</label>
              <input type="number" v-model="editModal.day_of_month" min="1" max="31" />
            </div>

            <div class="form-group" v-if="editModal.condType === 'dow'">
              <label>星期</label>
              <select v-model="editModal.day_of_week">
                <option value="0">週一</option><option value="1">週二</option>
                <option value="2">週三</option><option value="3">週四</option>
                <option value="4">週五</option><option value="5">週六</option>
                <option value="6">週日</option>
              </select>
            </div>

            <template v-if="editModal.condType === 'mdom'">
              <div class="form-group">
                <label>月份</label>
                <select v-model="editModal.month">
                  <option v-for="m in 12" :key="m" :value="m">{{ m }} 月</option>
                </select>
              </div>
              <div class="form-group">
                <label>日期</label>
                <input type="number" v-model="editModal.day_of_month" min="1" max="31" />
              </div>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="saveEdit" :disabled="editModal.saving">
            {{ editModal.saving ? '儲存中...' : '儲存' }}
          </button>
          <button class="btn btn-secondary" @click="closeEdit">取消</button>
          <span v-if="editModal.msg" class="msg-success">✓ {{ editModal.msg }}</span>
        </div>
      </div>
    </div>

    <!-- 規則列表 -->
    <div class="card">
      <div class="card-title">📋 現有規則</div>
      <div v-if="loading" class="loading">載入中...</div>
      <div v-else-if="rules.length === 0" class="empty">尚無排程規則</div>
      <div v-else class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th>類型</th>
              <th>項目 / 來源</th>
              <th>帳戶 / 目標</th>
              <th>金額</th>
              <th>備註</th>
              <th>觸發條件</th>
              <th>上次執行</th>
              <th>啟用</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in rules" :key="r.id" :class="{ 'row-disabled': !r.enabled }">
              <td><span :class="['badge', r.type === 'pay' ? 'badge-pay' : 'badge-transfer']">{{ r.type === 'pay' ? '支出' : '轉帳' }}</span></td>
              <td>{{ r.type === 'pay' ? r.item : r.source }}</td>
              <td>{{ r.type === 'pay' ? r.account : r.target }}</td>
              <td class="amount">{{ r.amount.toLocaleString() }}</td>
              <td>{{ r.comment || '-' }}</td>
              <td>{{ formatCond(r) }}</td>
              <td>{{ r.last_run_date || '-' }}</td>
              <td>
                <label class="toggle">
                  <input type="checkbox" :checked="r.enabled" @change="toggleRule(r)" />
                  <span class="toggle-slider"></span>
                </label>
              </td>
              <td class="td-actions">
                <button class="btn btn-edit btn-sm" @click="openEdit(r)">編輯</button>
                <button class="btn btn-danger btn-sm" @click="deleteRule(r)">刪除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/'

const DOW = ['週一', '週二', '週三', '週四', '週五', '週六', '週日']

export default {
  data() {
    return {
      rules: [],
      categories: [],
      assetList: [],
      loading: true,
      adding: false,
      msg: '',
      errMsg: '',
      form: {
        type: 'pay',
        item: null, account: null,
        source: null, target: null,
        amount: null, comment: '',
        condType: 'dom',
        day_of_month: null, day_of_week: '0', month: 1
      },
      editModal: {
        show: false, saving: false, msg: '',
        id: null, type: 'pay',
        item: null, account: null, source: null, target: null,
        amount: null, comment: '',
        condType: 'dom', day_of_month: null, day_of_week: '0', month: 1,
        enabled: true
      }
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      const h = this.authHeader()
      const [r1, r2, r3] = await Promise.all([
        axios.get('schedule_rules', h),
        axios.get('get_pay_item', h),
        axios.get('get_transfer_item', h)
      ])
      this.rules = (r1.data.rules || []).map(x => ({
        id: x[0], type: x[1], item: x[2], account: x[3],
        source: x[4], target: x[5], amount: x[6], comment: x[7],
        day_of_month: x[8], day_of_week: x[9], month: x[10],
        enabled: x[11], last_run_date: x[12]
      }))
      this.categories = r2.data
      this.assetList = r3.data
      this.form.item = this.categories[0]
      this.form.account = this.assetList[0]
      this.form.source = this.assetList[0]
      this.form.target = this.assetList[1] || this.assetList[0]
      this.loading = false
    },
    authHeader() {
      return { headers: { Authorization: 'Bearer ' + this.$store.getters.setToken } }
    },
    onTypeChange() {
      this.form.item = this.categories[0]
      this.form.account = this.assetList[0]
      this.form.source = this.assetList[0]
      this.form.target = this.assetList[1] || this.assetList[0]
    },
    formatCond(r) {
      if (r.day_of_week !== null && r.day_of_week !== undefined) return '每' + DOW[r.day_of_week]
      if (r.month) return r.month + '月 ' + r.day_of_month + '日'
      if (r.day_of_month) return '每月 ' + r.day_of_month + '日'
      return '-'
    },
    async addRule() {
      if (!this.form.amount) { this.errMsg = '請輸入金額'; return }
      this.adding = true; this.errMsg = ''
      const f = this.form
      const payload = {
        type: f.type,
        amount: parseFloat(f.amount),
        comment: f.comment,
        item: f.type === 'pay' ? f.item : null,
        account: f.type === 'pay' ? f.account : null,
        source: f.type === 'transfer' ? f.source : null,
        target: f.type === 'transfer' ? f.target : null,
        day_of_month: f.condType !== 'dow' ? parseInt(f.day_of_month) : null,
        day_of_week: f.condType === 'dow' ? parseInt(f.day_of_week) : null,
        month: f.condType === 'mdom' ? parseInt(f.month) : null,
        enabled: true,
        token: this.$store.getters.setToken
      }
      try {
        await axios.post('add_schedule_rule', payload)
        this.msg = '新增成功'
        setTimeout(() => this.msg = '', 3000)
        await this.loadData()
      } catch (e) {
        this.errMsg = '新增失敗'
      }
      this.adding = false
    },
    async toggleRule(r) {
      try {
        await axios.post('update_schedule_rule', {
          id: r.id, type: r.type,
          item: r.item, account: r.account,
          source: r.source, target: r.target,
          amount: r.amount, comment: r.comment,
          day_of_month: r.day_of_month, day_of_week: r.day_of_week, month: r.month,
          enabled: !r.enabled,
          token: this.$store.getters.setToken
        })
        r.enabled = !r.enabled
      } catch (e) { alert('更新失敗') }
    },
    openEdit(r) {
      const condType = r.day_of_week !== null && r.day_of_week !== undefined ? 'dow'
        : r.month ? 'mdom' : 'dom'
      Object.assign(this.editModal, {
        show: true, saving: false, msg: '',
        id: r.id, type: r.type,
        item: r.item, account: r.account,
        source: r.source, target: r.target,
        amount: r.amount, comment: r.comment || '',
        condType,
        day_of_month: r.day_of_month,
        day_of_week: r.day_of_week !== null && r.day_of_week !== undefined ? String(r.day_of_week) : '0',
        month: r.month || 1,
        enabled: r.enabled
      })
    },
    closeEdit() {
      this.editModal.show = false
    },
    onEditTypeChange() {
      this.editModal.item = this.categories[0]
      this.editModal.account = this.assetList[0]
      this.editModal.source = this.assetList[0]
      this.editModal.target = this.assetList[1] || this.assetList[0]
    },
    async saveEdit() {
      const e = this.editModal
      e.saving = true
      try {
        await axios.post('update_schedule_rule', {
          id: e.id, type: e.type,
          item: e.type === 'pay' ? e.item : null,
          account: e.type === 'pay' ? e.account : null,
          source: e.type === 'transfer' ? e.source : null,
          target: e.type === 'transfer' ? e.target : null,
          amount: parseFloat(e.amount),
          comment: e.comment,
          day_of_month: e.condType !== 'dow' ? parseInt(e.day_of_month) : null,
          day_of_week: e.condType === 'dow' ? parseInt(e.day_of_week) : null,
          month: e.condType === 'mdom' ? parseInt(e.month) : null,
          enabled: e.enabled,
          token: this.$store.getters.setToken
        })
        e.msg = '已儲存'
        setTimeout(() => { e.msg = ''; e.show = false }, 1200)
        await this.loadData()
      } catch (err) { alert('儲存失敗') }
      e.saving = false
    },
    async deleteRule(r) {
      if (!confirm(`確定刪除「${r.type === 'pay' ? r.item : r.source}」規則？`)) return
      try {
        await axios.post('delete_schedule_rule', { id: r.id, token: this.$store.getters.setToken })
        this.rules = this.rules.filter(x => x.id !== r.id)
      } catch (e) { alert('刪除失敗') }
    }
  }
}
</script>

<style scoped>
.page-header { margin-bottom: 24px; }
.page-header h1 { font-size: 24px; font-weight: 700; color: var(--text); }
.page-header p { color: var(--text-light); margin-top: 4px; font-size: 14px; }

.card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 20px;
  margin-bottom: 20px;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 130px;
}
.form-group label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-light);
}
.form-group select,
.form-group input[type=text],
.form-group input[type=number] {
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 14px;
  color: var(--text);
  background: #fff;
  outline: none;
  transition: border 0.15s;
}
.form-group select:focus,
.form-group input:focus { border-color: var(--primary); }

.form-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}
.msg-success { color: var(--success); font-size: 14px; }
.msg-error { color: var(--danger); font-size: 14px; }

.btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-primary { background: var(--primary); color: #fff; }
.btn-primary:hover:not(:disabled) { background: var(--primary-hover); }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-danger { background: #fef2f2; color: var(--danger); border: 1px solid #fecaca; }
.btn-danger:hover { background: #fee2e2; }
.btn-sm { padding: 4px 10px; font-size: 12px; }

.table-wrap { overflow-x: auto; }
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.data-table th {
  text-align: left;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-light);
  background: #f9fafb;
  border-bottom: 1px solid var(--border);
}
.data-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  color: var(--text);
}
.data-table tr:last-child td { border-bottom: none; }
.data-table tr:hover td { background: #f9fafb; }
.row-disabled td { color: var(--text-light); opacity: 0.6; }

.amount { font-weight: 600; color: var(--danger); }

.badge {
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 500;
}
.badge-pay { background: #fef3c7; color: #92400e; }
.badge-transfer { background: #dbeafe; color: #1e40af; }

.toggle { position: relative; display: inline-block; width: 36px; height: 20px; }
.toggle input { opacity: 0; width: 0; height: 0; }
.toggle-slider {
  position: absolute; inset: 0;
  background: #d1d5db; border-radius: 99px; cursor: pointer;
  transition: background 0.2s;
}
.toggle-slider::before {
  content: '';
  position: absolute;
  width: 14px; height: 14px;
  left: 3px; top: 3px;
  background: #fff; border-radius: 50%;
  transition: transform 0.2s;
}
.toggle input:checked + .toggle-slider { background: var(--primary); }
.toggle input:checked + .toggle-slider::before { transform: translateX(16px); }

.loading, .empty { text-align: center; color: var(--text-light); padding: 40px; }

.td-actions { display: flex; gap: 6px; align-items: center; }
.btn-edit { background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }
.btn-edit:hover { background: #dbeafe; }
.btn-secondary { background: #f3f4f6; color: var(--text); border: 1px solid var(--border); }
.btn-secondary:hover { background: #e5e7eb; }

.modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex; align-items: center; justify-content: center;
  z-index: 200;
}
.modal {
  background: #fff;
  border-radius: var(--radius);
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  width: 100%; max-width: 640px;
  max-height: 90vh; overflow-y: auto;
  margin: 16px;
}
.modal-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  font-weight: 600; font-size: 16px;
}
.modal-close {
  background: none; border: none; font-size: 16px;
  color: var(--text-light); cursor: pointer; padding: 4px 8px;
  border-radius: 4px;
}
.modal-close:hover { background: #f3f4f6; }
.modal-body { padding: 20px; }
.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  display: flex; gap: 10px; align-items: center;
}
</style>
